module.exports = __webpack_public_path__ + "back-end-tools.z7OMOxD3.svg";